/**
 *
 * Header
 *
 */

import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { styled } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import MenuIcon from "@material-ui/icons/Menu";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import definixBlackLogo from "../images/definix-black-logo.png";
import definixBlackMiniLogo from "../images/definix-black-mini-logo.png";
import en from "../images/en.png";
import kr from "../images/kr.png";
import th from "../images/th.png";
import { Context } from "../store/lang";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  border: "1px solid rgba(0,0,0,0.15)",
  borderRadius: "2rem",
  width: "max-content",

  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "2rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    textTransform: "initial",
    transition: "0.2s",

    "&.Mui-disabled": {
      border: 0,
    },
    "&.Mui-selected": {
      background: theme.palette.primary.main,
      color: "#fff",
    },
  },
}));

const CustomToggleButton = ({ className }) => {
  const [value, setValue] = useState("v1");

  const handleChange = (e, newValue) => {
    if (newValue !== null) {
      setValue(newValue);
    }
  };

  return (
    <StyledToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      className={className}
    >
      <ToggleButton
        value="v1"
        href="https://definix.com/"
        target="_self"
        rel="noreferrer"
      >
        G1
      </ToggleButton>
      <ToggleButton
        value="g2"
        href="https://g2.definix.com/"
        target="_self"
        rel="noreferrer"
      >
        G2 Beta
      </ToggleButton>
    </StyledToggleButtonGroup>
  );
};

function Header(props) {
  const anchorEl = useRef(null);
  const [scroll, setScroll] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const context = useContext(Context);
  const { location } = props;
  const path = location.pathname.slice(0, location.pathname.lastIndexOf("/"));
  const langs = [
    { label: "English", locale: "en", img: en },
    { label: "Korean", locale: "ko", img: kr },
    { label: "Thai", locale: "th", img: th },
  ];
  const curLang = langs.filter((l) => l.locale === context.lang.get)[0];

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset > 80) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    return () => {
      window.onscroll = null;
    };
  }, []);

  const handleDrawerToggle = () => {
    setShowMenu(!showMenu);
  };

  const handleClose = () => {
    setShowLang(false);
  };

  const menu = () => (
    <>
      <Button
        color="inherit"
        component={NavLink}
        to={`/info/${context.lang.get}`}
        activeClassName="text-bold color-primary"
      >
        What is FINIX token?
      </Button>
      <Button color="inherit" href="https://bridge.six.network" target="_blank">
        SIX Bridge
      </Button>
      <Button
        color="inherit"
        ref={anchorEl}
        onClick={() => {
          setShowLang(true);
        }}
        aria-controls="simple-menu"
        aria-haspopup="true"
      >
        <img
          src={curLang ? curLang.img : langs[0].img}
          alt=""
          className="mr-2"
        />
        {curLang ? curLang.label : langs[0].label}
      </Button>
      <Menu
        anchorEl={anchorEl.current}
        open={showLang}
        onClose={handleClose}
        onClick={handleClose}
        elevation={1}
        keepMounted
      >
        {langs.map((l) => (
          <MenuItem component={Link} to={`${path}/${l.locale}`} key={l.locale}>
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );

  return (
    <>
      <AppBar position="sticky" color="transparent" elevation={scroll ? 1 : 0}>
        <Container disableGutters>
          <Toolbar className="flex justify-space-between align-center">
            <div className="flex align-center">
              <NavLink to={`/${context.lang.get}`}>
                {isWidthUp("sm", props.width) ? (
                  <img src={definixBlackLogo} alt="" className="logo" />
                ) : (
                  <img
                    src={definixBlackMiniLogo}
                    alt=""
                    className="logo-mini"
                  />
                )}
              </NavLink>
              {isWidthUp("sm", props.width) && (
                <CustomToggleButton className="ml-5" />
              )}
            </div>

            <div className="flex align-center">
              {isWidthUp("sm", props.width) && menu()}
              {!isWidthUp("sm", props.width) && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                >
                  <MenuIcon />
                </IconButton>
              )}

              <Button
                size="small"
                color="primary"
                variant="contained"
                disableElevation
                href="https://bsc.definix.com"
                target="_blank"
                className="ml-4"
              >
                Launch App
              </Button>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
      <Hidden smUp>
        <Drawer
          variant="temporary"
          anchor="right"
          open={showMenu}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ className: "pa-4" }}
        >
          {menu()}
          <CustomToggleButton className="mt-3 mx-auto" />
        </Drawer>
      </Hidden>
    </>
  );
}

Header.propTypes = {};

export default withWidth()(withRouter(Header));
